import axios from 'axios';
import qs from 'qs';

export default {
    state: {
        types: null,
        tags: null,
        vendors: null,
        languages: {},
        platforms: {},
    },
    mutations: {
        set_types: (state, payload) => {
            state.types = payload;
        },
        set_tags: (state, payload) => {
            state.tags = payload;
        },
        set_vendors: (state, payload) => {
            state.vendors = payload;
        },
        set_language: (state, payload) => {
            const languages = {};
            for (let language of payload) {
                if (!languages[language.country]) languages[language.country] = [];
                languages[language.country].push(language);
            }
            state.languages = languages;
        },
        set_platforms: (state, payload) => {
            const platforms = {};
            for (let platform of payload) {
                platforms[platform.id] = platform;
            }
            state.platforms = platforms;
        },
    },
    actions: {
        get_types: async (ctx, payload) => {
            await axios.get(process.env.VUE_APP_BACKEND_HOST + "/api/user_type/all").then(
                function(response) {
                    if (response.status === 200 && response.data.status === "success") {
                        const types = response.data.result;
                        ctx.commit('set_types', types);
                    }
                }
            );
        },
        get_tags: async (ctx, payload) => {
            await axios.get(process.env.VUE_APP_BACKEND_HOST + "/api/tag/all").then(
                function(response) {
                    if (response.status === 200 && response.data.status === "success") {
                        const tags = response.data.result;
                        ctx.commit('set_tags', tags);
                    }
                }
            );
        },
        get_vendors: async (ctx, payload) => {
            await axios.get(process.env.VUE_APP_BACKEND_HOST + "/api/vendor/all").then(
                function(response) {
                    if (response.status === 200 && response.data.status === "success") {
                        const vendors = response.data.result;
                        ctx.commit('set_vendors', vendors);
                    }
                }
            );
        },
        get_languages: async (ctx, payload) => {
            await axios.get(process.env.VUE_APP_BACKEND_HOST + "/api/language/all").then(
                function(response) {
                    if (response.status === 200 && response.data.status === "success") {
                        const languages = response.data.result;
                        ctx.commit('set_language', languages);
                    }
                }
            );
        },
        get_platforms: async (ctx, payload) => {
            await axios.get(process.env.VUE_APP_BACKEND_HOST + "/api/platform/all").then(
                function(response) {
                    if (response.status === 200 && response.data.status === "success") {
                        const platforms = response.data.result;
                        ctx.commit('set_platforms', platforms);
                    }
                }
            );
        }
    },

    getters: {
        getUserTypes(state) {
            const userGroups = [];
            for (const item of state.types) {
                userGroups.push({
                    groupName: item.name,
                    id: item.id
                })
            }
            return userGroups;
        },
        getTags(state) {
            const tags = [{id: 0, tagName: "All"}];
            for (const item of state.tags) {
                tags.push({
                    tagName: item.name,
                    id: item.id
                })
            }
            return tags;
        },
        getVendors(state) {
            const vendors = [{id: 0, vendorName: "All"}];
            for (const item of state.vendors) {
                vendors.push({
                    vendorName: item.name,
                    id: item.id
                })
            }
            return vendors;
        },
        getLanguages(state) {
            return state.languages;
        },
        getPlatforms(state) {
            return state.platforms;
        }
    }
}